import { render, staticRenderFns } from "./PersonalDataExport.vue?vue&type=template&id=6d6e265d&scoped=true"
import script from "./PersonalDataExport.vue?vue&type=script&lang=js"
export * from "./PersonalDataExport.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataExport.vue?vue&type=style&index=0&id=6d6e265d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e265d",
  null
  
)

export default component.exports